import * as React from 'react';

import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Text } from '@shared/components/bootstrap';

export const Spinner: React.FC = () => (
  <Text alignment="center" style="muted" tag="div">
    <FontAwesomeIcon spin icon={faSpinner} />
  </Text>
);
